module.exports = __webpack_public_path__ + "img/brown.14dd372b.png";